exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".XbrStatus_container_2NWN {\n  margin-bottom: 10px;\n\n  max-width: 100%;\n\n  text-align: left;\n}\n", ""]);

// exports
exports.locals = {
	"container": "XbrStatus_container_2NWN"
};